<app-header></app-header>

<div class="p-4">

  <!-- En-tête -->
  <div class="flex items-center justify-between flex-wrap gap-3 mb-5">
    <div class="flex items-center gap-3 pl-3 border-l-4 border-ag-red">
      <div>
        <h2 class="text-lg font-bold text-gray-900 m-0">Rapports financiers</h2>
        <p class="text-xs text-gray-400 m-0">Compte de résultat : recettes, dépenses, budget prévu vs réalisé</p>
      </div>
    </div>
    <button (click)="print()"
            class="px-3 py-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm transition-colors">
      🖨️ Imprimer
    </button>
  </div>

  <!-- Filtres période -->
  <div class="rounded-xl border border-gray-100 bg-white shadow-sm p-4 mb-5 flex flex-wrap items-end gap-3">
    <div>
      <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Du</label>
      <input type="date" [(ngModel)]="filters.from"
             class="border border-gray-200 rounded-lg px-3 py-1.5 text-sm outline-none focus:border-ag-red">
    </div>
    <div>
      <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Au</label>
      <input type="date" [(ngModel)]="filters.to"
             class="border border-gray-200 rounded-lg px-3 py-1.5 text-sm outline-none focus:border-ag-red">
    </div>
    <button (click)="load()" class="px-4 py-1.5 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold">Filtrer</button>
    <button (click)="resetFilters()" class="px-4 py-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm">Réinitialiser</button>
  </div>

  <app-loading [isVisible]="loading"></app-loading>

  @if (report) {
    <!-- Cartes synthèse -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5">
      <!-- Recettes -->
      <div class="rounded-xl border border-gray-100 bg-white shadow-sm p-5">
        <p class="text-xs text-gray-400 uppercase tracking-wide m-0">Recettes</p>
        <p class="text-2xl font-bold text-green-600 mt-1 mb-2">{{report.recettes.realisees | number}} <span class="text-sm font-normal">FCFA</span></p>
        <div class="text-xs text-gray-500">
          Prévu : {{report.recettes.prevues | number}} F
          <span class="ml-1 px-1.5 py-0.5 rounded bg-green-50 text-green-700">{{report.recettes.taux}}%</span>
        </div>
        <div class="mt-2 h-1.5 rounded-full bg-gray-100 overflow-hidden">
          <div class="h-full bg-green-500" [style.width.%]="report.recettes.taux > 100 ? 100 : report.recettes.taux"></div>
        </div>
      </div>
      <!-- Dépenses -->
      <div class="rounded-xl border border-gray-100 bg-white shadow-sm p-5">
        <p class="text-xs text-gray-400 uppercase tracking-wide m-0">Dépenses</p>
        <p class="text-2xl font-bold text-ag-red mt-1 mb-2">{{report.depenses.realisees | number}} <span class="text-sm font-normal">FCFA</span></p>
        <div class="text-xs text-gray-500">
          Prévu : {{report.depenses.prevues | number}} F
          <span class="ml-1 px-1.5 py-0.5 rounded bg-red-50 text-ag-red">{{report.depenses.taux}}%</span>
        </div>
        <div class="mt-2 h-1.5 rounded-full bg-gray-100 overflow-hidden">
          <div class="h-full bg-ag-red" [style.width.%]="report.depenses.taux > 100 ? 100 : report.depenses.taux"></div>
        </div>
      </div>
      <!-- Résultat -->
      <div class="rounded-xl border shadow-sm p-5"
           [ngClass]="report.resultat.realise >= 0 ? 'border-green-200 bg-green-50' : 'border-red-200 bg-red-50'">
        <p class="text-xs text-gray-400 uppercase tracking-wide m-0">Résultat (recettes − dépenses)</p>
        <p class="text-2xl font-bold mt-1 mb-2"
           [ngClass]="report.resultat.realise >= 0 ? 'text-green-700' : 'text-ag-red'">
          {{report.resultat.realise | number}} <span class="text-sm font-normal">FCFA</span>
        </p>
        <div class="text-xs text-gray-500">Prévisionnel : {{report.resultat.previsionnel | number}} F</div>
        <div class="text-xs mt-1 font-semibold" [ngClass]="report.resultat.realise >= 0 ? 'text-green-700' : 'text-ag-red'">
          {{report.resultat.realise >= 0 ? '✓ Excédent' : '⚠ Déficit'}}
        </div>
      </div>
    </div>

    <!-- Compte de résultat -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Tableau récapitulatif -->
      <div class="rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden">
        <div class="px-4 py-3 border-b border-gray-100 bg-gray-50">
          <h3 class="font-bold text-sm text-gray-800 m-0">Compte de résultat simplifié</h3>
        </div>
        <table class="w-full text-sm">
          <tbody>
            <tr class="border-b border-gray-50">
              <td class="px-4 py-3 text-gray-600">Total recettes réalisées</td>
              <td class="px-4 py-3 text-end font-semibold text-green-600">+ {{report.recettes.realisees | number}} F</td>
            </tr>
            <tr class="border-b border-gray-50">
              <td class="px-4 py-3 text-gray-600">Total dépenses réalisées</td>
              <td class="px-4 py-3 text-end font-semibold text-ag-red">− {{report.depenses.realisees | number}} F</td>
            </tr>
            <tr class="bg-gray-50">
              <td class="px-4 py-3 font-bold text-gray-800">Résultat net</td>
              <td class="px-4 py-3 text-end font-bold"
                  [ngClass]="report.resultat.realise >= 0 ? 'text-green-700' : 'text-ag-red'">
                {{report.resultat.realise | number}} F
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Dépenses par catégorie -->
      <div class="rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden">
        <div class="px-4 py-3 border-b border-gray-100 bg-gray-50">
          <h3 class="font-bold text-sm text-gray-800 m-0">Dépenses par catégorie</h3>
        </div>
        @if (report.depenses.par_categorie.length > 0) {
          <table class="w-full text-sm">
            <tbody>
              @for (c of report.depenses.par_categorie; track c.category) {
                <tr class="border-b border-gray-50">
                  <td class="px-4 py-2.5 text-gray-600">{{c.category}}</td>
                  <td class="px-4 py-2.5 text-end font-semibold text-gray-800">{{c.total | number}} F</td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p class="text-center text-gray-400 py-6 text-sm">Aucune dépense sur la période.</p>
        }
      </div>
    </div>
  }
</div>
